import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, space, transition } from './neonUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Radio', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}-wrapper${DOT_PREFIX}`]: {
      [`${componentCls}-inner`]: {
        borderColor: `${cyan[500]}30 !important`,
        background: `${space[800]} !important`,
        transition,
      },

      '&:hover': {
        [`${componentCls}-inner`]: {
          borderColor: `${cyan[500]}60 !important`,
        },
      },

      [`${componentCls}-checked`]: {
        [`${componentCls}-inner`]: {
          borderColor: `${cyan[500]}80 !important`,
          background: `${space[800]} !important`,
          boxShadow: `0 0 6px ${cyan[500]}25`,

          '&:after': {
            background: `${cyan[500]} !important`,
            boxShadow: `0 0 4px ${cyan[500]}80`,
          },
        },
      },
    },
  }
})
